/**
 * © 2026 Madar.iq — All Rights Reserved.
 * This software is proprietary and confidential.
 */

(function () {
  "use strict";

  const userAgent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  const hostname = window.location.hostname || "";
  const isLocalHost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]";

  const isDev =
    isLocalHost ||
    process.env.NODE_ENV === "development" ||
    process.env.REACT_APP_ALLOW_DEVTOOLS === "true";

  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1);

  const isMobileSafari =
    /Safari/i.test(userAgent) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Android/i.test(userAgent);

  const skipAggressiveProtection = isIOS || isMobileSafari;

  if (isDev) return;

  document.addEventListener("keydown", function (e) {
    if (
      e.ctrlKey &&
      e.shiftKey &&
      (e.key === "I" || e.key === "i" || e.key === "J" || e.key === "j" || e.key === "C" || e.key === "c")
    ) {
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && (e.key === "U" || e.key === "u")) {
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && (e.key === "S" || e.key === "s")) {
      e.preventDefault();
      return false;
    }
  });

  document.addEventListener("dragstart", function (e) {
    e.preventDefault();
    return false;
  });

  if (!skipAggressiveProtection) {
    setInterval(function () {
      (function () {
        return false;
      })
        .constructor("debugger")
        .call();
    }, 10000);
  }

  const noop = function () {};
  const protectionMsg = [
    "%cSTOP! هذا التطبيق محمي",
    "color:#ef4444;font-size:24px;font-weight:bold;",
  ];
  const infoMsg = [
    "%c© 2026 Madar.iq — جميع الحقوق محفوظة",
    "color:#f59e0b;font-size:13px;",
  ];

  setTimeout(function () {
    if (typeof console !== "undefined") {
      try {
        console.log(...protectionMsg);
        console.log(...infoMsg);

        const originalError = console.error;
        console.log = noop;
        console.warn = noop;
        console.info = noop;
        console.debug = noop;
        console.dir = noop;
        console.table = noop;

        console.error = function (...args) {
          if (args[0] && typeof args[0] === "string" && args[0].includes("[Madar.iq]")) {
            originalError.apply(console, args);
          }
        };
      } catch (e) {
        // ignore
      }
    }
  }, 500);

  try {
    const stamp = btoa(
      JSON.stringify({
        product: "Madar.iq",
        license: "PROPRIETARY",
        year: 2026,
        warning: "Unauthorized use prohibited",
      })
    );
    window.localStorage.setItem("_madar_protected", stamp);
  } catch (e) {
    // ignore
  }

  if (window.self !== window.top) {
    try {
      window.top.location = window.self.location;
    } catch (e) {
      // ignore cross-origin issues
    }
  }
})();
